var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-box"},[_c('img',{attrs:{"src":require("../../assets/images/404.jpg")}}),_vm._v(" "),_c('p',[_vm._v("您请求的页面不存在！")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":_vm.checkToIndex}},[_vm._v("\n    返回首页\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ebd6d4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/error/Error.vue
// module id = null
// module chunks = 